import { render, staticRenderFns } from "./lkuKoraniklan.vue?vue&type=template&id=72ffe060"
import script from "./lkuKoraniklan.vue?vue&type=script&lang=js"
export * from "./lkuKoraniklan.vue?vue&type=script&lang=js"
import style0 from "./lkuKoraniklan.vue?vue&type=style&index=0&id=72ffe060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports